import {
  pluralize as pluralizeWord,
  singularize as singularizeWord,
} from '@warp-drive/utilities/string';

// The ember-inflector API on the WarpDrive rule tables, so that the templates
// and the store use the same rules (see models/custom-inflector-rules).
//
// WarpDrive throws in debug builds for an empty word and gives '' otherwise.
// ember-inflector gives a blank or missing word back unchanged, so these do
// too.

export interface PluralizeOptions {
  withoutCount?: boolean;
}

const isBlank = (word: unknown): boolean =>
  typeof word !== 'string' || word.trim() === '';

// pluralize('ox') is 'oxen'. pluralize(2, 'ox') is '2 oxen' and
// pluralize(1, 'ox') is '1 ox'. With { withoutCount: true }, the count is not
// in the result.
export function pluralize(word: string): string;
export function pluralize(
  count: number | string,
  word: string | null | undefined,
  options?: PluralizeOptions,
): string;
export function pluralize(
  ...[wordOrCount, word, { withoutCount = false } = {}]: [
    number | string,
    (string | null | undefined)?,
    PluralizeOptions?,
  ]
): string {
  if (arguments.length === 1) {
    return isBlank(wordOrCount)
      ? (wordOrCount as string)
      : pluralizeWord(wordOrCount as string);
  }

  // As ember-inflector: a missing word gives '2 ', not '2 undefined'.
  const inflected =
    word == null
      ? ''
      : parseFloat(wordOrCount as string) === 1 || isBlank(word)
        ? word
        : pluralizeWord(word);

  return withoutCount ? inflected : `${wordOrCount} ${inflected}`;
}

export function singularize(word: string): string {
  return isBlank(word) ? word : singularizeWord(word);
}
